export enum enumDLIBFeeGroups {
  'Microlender' = 1,
  'Office Account',
  'Client',
  'Zz MycoCard',
  'Zz Development',
  'Concession',
  'Zz Super Terminal',
  'Zz MSP Client',
  'Zz KGS Group',
  'Zz KGS Pocket',
  'Zz Software Only',
  'Zz LSP',
  'Concession Volume',
  'Business Silver',
  'Concession Max',
  'Microlender Max',
  'EPA Group',
  'Zz Development M',
  'Zz CellPhone',
  'Classic',
  'Classic Lite',
  'Wealth & Rewards',
  'Zz PDA WR',
  'StatusMoney',
  'Cash Access',
  'Business Platinum',
  'Professional',
  'Wizzit',
  'Wizzit Business',
  'Zz WizzKids',
  'SS Terminal Supervisor Card',
  'SS Terminal Admin Card',
  'Consumer Fair',
  'ePocket',
  'SureE',
  'XTRA-MOVA',
  'PayM8 Agents',
  'PayM8 Staff',
  'Percent_Zero',
  'mB Insurance',
  'Percent_Two',
  'Percent_TwoFive',
  'mB Executive',
  'Percent_One',
  'Universal Business',
  'mB Full Spectrum Merchant',
  'mB Processing',
  'SS-SASSA',
  'Flexifusion',
  'mB Fixed Network',
  'mb eWallet',
  'VPS Business',
  'mb OMHP Merchant',
  'Allocated Merchant',
  'Intecon Merchant',
  'mB GAP',
  'Amber Personnel',
  'Business Gold',
  'Business OnTheGo',
  'mB SME Wallet',
  'Classic X',
  'Classic Plus',
  'Paysoft'
}

export namespace enumDLIBFeeGroups {
  export function values() {
    return Object.keys(enumDLIBFeeGroups).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
